import { NgStyle } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { doc, Firestore, getDoc } from "@angular/fire/firestore";
import { FormsModule } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Data, NavigationEnd, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { LoadingService } from "@core/loading.service";
import { UtilityService } from "@core/utility.service";
import { IonicModule, NavController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { combineLatest, from, of, Subject, Subscription } from "rxjs";
import { catchError, map, switchMap, take, takeUntil } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { CheckoutFlowService } from "src/app/services/checkout-flow.service";
import { LoginDataResolverService } from "src/app/services/login-data-resolver.service";
import { PaymentService } from "src/app/services/payment.service";
import { SalesJourneyIdentityService } from "src/app/services/sales-journey-identity.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { environment } from "src/environments/environment";
import { v4 as uuidv4 } from "uuid";
import {
  AccountAddCardCheckoutFlowService,
  AccountAddCardFlowHost,
} from "./services/account-add-card-checkout-flow.service";
declare var window;

@Component({
  selector: "app-custom-add-card",
  templateUrl: "./custom-add-card.component.html",
  styleUrls: ["./custom-add-card.component.scss"],
  standalone: true,
  imports: [IonicModule, FormsModule, NgStyle, TranslatePipe],
})
export class CustomAddCardComponent implements OnInit, OnDestroy {
  paymentReason = "";
  paymentDone = false;
  url = "";
  count = 0;
  paymentReceived: boolean;
  paymentDetail: Data;
  payment_status: Data;
  defaultPrice = 0;
  isPaymill = false;
  isCheckOutCom = true;
  isCheckoutComform = true;
  redirectlink: Data;
  showCheckOutComSpinner = false;
  userData: Data;
  checkOutComData: Data;
  preferredCurrency = "GBP";
  currencySymbol = "£";
  selectedLanguage: string = "en";
  private unsubscribe$ = new Subject<void>();
  currencyBasedPType: string;
  myuuid: string = uuidv4();
  pathString: string;
  customerPurchaseEncryptedId: Data;
  customerPurchaseResponce: Data;
  pType: string;
  jackpotTriggerObj: {
    lines: number;
    jackpot: string;
    price: number;
    offer_link_id: number;
    offer_id: number;
    free_jackpot: boolean;
    alternate_free_jackpot: boolean;
    free_offer_id: string | number;
  };
  offerId: string;
  public isButtonDisabled: boolean;
  public language: string;
  public keys: Data;
  public token: string;
  public errorMessage: string;
  public errorStack: string[] = [];
  public fbTokenKey = "fbToken";
  public userIdKey = "userId";
  selectedCard: string;
  preAuthAmount: number;
  hideSpinner: boolean;
  origin = window.location.origin;
  private coPurchaseDetails: Data;
  tokenValidaterSub: Subscription;
  private getCheckOutComResponseSubscription: Subscription;
  private checkoutFlowRedirectHandled = false;
  private flowMountAttempted = false;
  private checkoutApiKeysReady = false;
  /** True after the user has left this view once; skips first-entry ionViewWillEnter remount. */
  private hasLeftAddCardView = false;
  checkoutFlowReady = false;
  cardTokenizedCalled = false;
  private checkoutFlowService = inject(CheckoutFlowService);
  private accountAddCardCheckoutFlowService = inject(AccountAddCardCheckoutFlowService);
  private changeDetRef = inject(ChangeDetectorRef);
  userId: string;
  paymentMode: string;
  routeStack: string[] = [];
  private readonly ALLOWED_ORIGINS: string[] = [
    "https://api.checkout.com",
    "https://api.sandbox.checkout.com",
    window.location.origin,
  ];

  constructor(
    private navController: NavController,
    public translate: TranslateService,
    private paymentService: PaymentService,
    private utilityService: UtilityService,
    private router: Router,
    private afs: AngularFirestore,
    private angularFireAuth: AngularFireAuth,
    private authService: AuthService,
    private injector: Injector,
    public angularFireFunctions: AngularFireFunctions,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private userManagementService: UserManagementService,
    private loadingService: LoadingService,
    private firestore: Firestore,
    private actRoute: ActivatedRoute,
    private salesJourneyIdentityService: SalesJourneyIdentityService,
  ) {
    // This method has been used to create a subscription to get the user data from firebase
    combineLatest([this.authService.userDetails$, this.authService.getCurrencyList$])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ([user, data]) => {
          this.userData = user;
          this.preferredCurrency = user?.preferred_currency ?? "GBP";
          const details = (data as Data)?.details ?? [];
          const currencyDetails = details.find((x: Data) => x?.currency_code === this.preferredCurrency);

          this.currencySymbol = currencyDetails?.currency_symbol ?? "£";
        },
        error: (err) => {
          // Fallback handling (no console as per policy)
          this.authService.errorHandlerLogs("Unable to load currency details. Default applied.", err);
        },
      });

    this.authService?.selectedlanguage$?.pipe(takeUntil(this.unsubscribe$))?.subscribe({
      next: (language) => {
        const currentLanguage = language ? language : "en";
        this.selectedLanguage = currentLanguage;
        translate.use(currentLanguage);

        if (window?.wpwlOptions) {
          window.wpwlOptions.locale = this.selectedLanguage ?? "en";
        }
      },
      error: (err) => {
        return err;
      },
    });
    // Router events
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((e) => {
      if (e instanceof NavigationEnd) {
        const url = e.urlAfterRedirects;
        if (this.routeStack.at(-1) !== url) this.routeStack.push(url);
      }
    });
  }

  @HostListener("window:message", ["$event"])
  onMessage(e: MessageEvent) {
    if (!e.origin || !this.ALLOWED_ORIGINS.includes(e.origin)) return;
    if (e?.data?.for === "paymentDone") {
      this.afterNewCardPaymentDone();
    }
  }

  async ngOnInit() {
    // Keep first-entry identical to the pre-HATDEV-98974 path. Full teardown/reset
    // belongs only in ionViewWillEnter remount — calling it here races Flow mount
    // and surfaces "Failed to initialize payment form".
    void this.checkoutFlowService.preloadSdk().catch(() => undefined);

    const qp = this.actRoute.snapshot?.queryParams ?? {};
    this.paymentMode = qp.pt ?? "";
    this.pathString = String(this.myuuid);
    this.isCheckOutCom = true;
    this.isPaymill = false;
    this.selectedCard = "21";
    this.hideSpinner = true;
    this.isCheckoutComform = true;
    this.showCheckOutComSpinner = true;
    this.changeDetRef.detectChanges();

    this.prefetchCheckoutApiKeys();
    if (this.handleCheckoutFlowRedirect()) {
      return;
    }

    void this.authService
      ?.getUid("CustomAddCardComponent")
      ?.then((uid) => {
        this.userId = uid;
        if (uid) {
          this.paymentService.checkoutFlowUserId$.next(uid);
        }
        this.scheduleCheckoutWarmStart();
        void this.tryMountCheckoutFlow();
      })
      .catch((error) => error);

    this.loadPreAuthOfferAndStartCheckout();
    const interval = setInterval(() => {
      if (document.getElementsByClassName("wpwl-form").length) {
        this.hideSpinner = true;
        clearInterval(interval);
      }
    }, 1000);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        void this.tryMountCheckoutFlow();
      });
    });
  }

  /**
   * Ionic may keep this page in the stack after a successful first-card add.
   * Re-enter must clear post-pay host flags and remount Flow for a second card.
   * First enter is owned by ngOnInit — remounting here races Flow mount.
   */
  ionViewWillEnter(): void {
    if (!this.hasLeftAddCardView) {
      return;
    }

    const hasInitFailure =
      !this.checkoutFlowReady &&
      !!this.errorMessage &&
      !this.isCheckoutLoadingMessage(this.errorMessage);
    const needsRemount =
      this.cardTokenizedCalled || !this.isCheckoutComform || hasInitFailure;
    if (!needsRemount) {
      return;
    }

    this.resetCheckoutFlowHostStateForEntry();
    this.changeDetRef.detectChanges();

    if (this.handleCheckoutFlowRedirect()) {
      return;
    }

    // Do not warm-start/mount here with stale coPurchaseDetails / customer_purchase —
    // that reuses a consumed first-card session and fails Flow init.
    // loadPreAuthOfferAndStartCheckout bootstraps a fresh purchase then mounts.
    this.prefetchCheckoutApiKeys();
    if (this.userId) {
      this.paymentService.checkoutFlowUserId$.next(this.userId);
    }
    this.loadPreAuthOfferAndStartCheckout();
  }

  ionViewWillLeave(): void {
    this.hasLeftAddCardView = true;
  }

  /**
   * Clears post-payment / remount guards so Add Payment Method can show Flow again.
   */
  private resetCheckoutFlowHostStateForEntry(): void {
    this.accountAddCardCheckoutFlowService.teardown();
    this.myuuid = uuidv4();
    this.pathString = String(this.myuuid);
    this.flowMountAttempted = false;
    this.checkoutFlowReady = false;
    this.cardTokenizedCalled = false;
    this.checkoutFlowRedirectHandled = false;
    this.isCheckoutComform = true;
    this.showCheckOutComSpinner = true;
    this.isButtonDisabled = true;
    this.errorMessage = "";
    this.redirectlink = null;
    // Drop consumed purchase/session host data so canPrepareCheckoutSession stays
    // false until loadPreAuthOfferAndStartCheckout creates a new pre-auth purchase.
    this.checkOutComData = undefined;
    this.coPurchaseDetails = undefined;
    this.customerPurchaseResponce = undefined;
    this.paymentDetail = undefined;
    this.preAuthAmount = undefined;
    this.getCheckOutComResponseSubscription?.unsubscribe();
    this.getCheckOutComResponseSubscription = undefined;
  }

  private loadPreAuthOfferAndStartCheckout(): void {
    const systemRefDoc = doc(this.firestore, `/general_modules/${environment.mirrorPath}system_reference`);

    from(getDoc(systemRefDoc))
      .pipe(
        switchMap((snapshot) => {
          const systemPreference = snapshot.data();
          if (!systemPreference) {
            return of({ offer: { price: this.defaultPrice }, systemPreference: null });
          }

          this.offerId = systemPreference.pre_auth_offer_id;
          this.preAuthAmount = systemPreference.pre_auth_amount;
          this.bootstrapCheckoutComSession();

          const offerDocRef = doc(this.firestore, `/general_modules/offer_listing/offers/${this.offerId}`);

          return from(getDoc(offerDocRef)).pipe(
            map((offerSnap) => ({
              offer: offerSnap.data() ?? { price: this.defaultPrice },
              systemPreference,
            })),
            catchError(() => of({ offer: { price: this.defaultPrice }, systemPreference })),
          );
        }),
        catchError(() => of({ offer: { price: this.defaultPrice }, systemPreference: null })),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(({ offer }) => {
        this.completeCheckoutComSetup(offer as Data);
        this.resolvePaymentTypeInBackground(offer as Data);
      });
  }

  private bootstrapCheckoutComSession(): void {
    this.coPurchaseDetails = {
      prize: this.preAuthAmount,
      offers: { price: this.preAuthAmount },
      offer_id: this.offerId,
      p_type: "21",
      checkout: true,
      page: "store",
    };
    this.scheduleCheckoutWarmStart();
    void this.tryMountCheckoutFlow();
  }

  private completeCheckoutComSetup(offer: Data): void {
    localStorage.removeItem("d");
    const purchaseDetails = this.formPaymentDataForTopUp(offer);
    purchaseDetails["p_type"] = this.selectedCard || "21";
    this.coPurchaseDetails = { ...purchaseDetails };
    this.scheduleCheckoutWarmStart();
    void this.tryMountCheckoutFlow();

    this.paymentService.insertCustomerPurchase(purchaseDetails, "").subscribe(
      (result) => {
        this.paymentDetail = result;
        if (result?.response && result?.response?.status === "SUCCESS") {
          this.customerPurchaseResponce = result?.response;
          this.paymentDetail = result;
          this.paymentDetail["offer_id"] = this.offerId;
          this.paymentDetail["price"] = this.preAuthAmount;
          this.checkOutComData = {
            ...this.paymentDetail,
            ...{ customer_purchase: this.customerPurchaseResponce },
            ...this.userData,
          };
          if (this.userId) {
            this.paymentService.checkoutFlowUserId$.next(this.userId);
          }
          this.syncCheckoutFlowPayButtonState();
          // Remount once customer_purchase exists (second-card / remount safety).
          // Allow retry if an earlier mount attempt failed or exited before ready.
          if (!this.checkoutFlowReady) {
            this.flowMountAttempted = false;
            this.errorMessage = "";
          }
          void this.tryMountCheckoutFlow();
        } else if (result && result.message === "Timeout has occurred") {
          this.paymentDone = false;
          this.authService.getConstantsMsg(result.message?.error_code).then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          });
        }
      },
      () => {
        const defaultMsg = {
          message: {
            line_1: "Something went wrong!",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(null, defaultMsg);
      },
    );
  }

  private resolvePaymentTypeInBackground(offer: Data): void {
    const offer_p_type = offer?.p_type;
    const currency = this.preferredCurrency || this.userManagementService?.selectedCurrency || "GBP";

    this.paymentService
      .getPTypeByPreferredCurrency(currency)
      .pipe(take(1))
      .subscribe({
        next: (currencyData) => {
          this.currencyBasedPType = currencyData?.[0]?.id ?? "10";
        },
        error: () => {
          this.currencyBasedPType = "10";
        },
      });

    this.paymentService
      .getPTypeByOffer(offer_p_type)
      .pipe(take(1))
      .subscribe((currency: Data) => {
        const offerCurrencyData = currency?.data() as { valid_currency: Array<Data> };
        const offerValidCurrencyAry = offerCurrencyData?.valid_currency;
        const resolvedPType =
          Array.isArray(offerValidCurrencyAry) && offerValidCurrencyAry.includes(currency)
            ? String(offer_p_type)
            : this.currencyBasedPType;

        if (resolvedPType === "10") {
          this.accountAddCardCheckoutFlowService.unmount();
          this.isCheckOutCom = false;
          this.isPaymill = true;
          this.selectedCard = resolvedPType;
          this.pType = resolvedPType;
          this.flowMountAttempted = false;
          this.changeDetRef.detectChanges();
          this.loadPaymillPaymentData();
          return;
        }

        this.selectedCard = resolvedPType;
        this.pType = resolvedPType;
        if (this.coPurchaseDetails) {
          this.coPurchaseDetails["p_type"] = resolvedPType;
        }
      });
  }

  private syncCheckoutFlowPayButtonState(): void {
    if (!this.checkoutFlowReady) {
      return;
    }
    this.isButtonDisabled = !this.checkOutComData?.customer_purchase;
    this.changeDetRef.detectChanges();
  }
  async loadPaymillPaymentData() {
    localStorage.removeItem("d");
    const currency = this.userManagementService?.selectedCurrency || CommonVariable?.preferredCurrency || "GBP";

    this.getSystemPreferenceOfferId().subscribe((offer) => {
      const additionalPayload = {
        payment_type: "PA",
      };
      this.paymentService
        .getCheckoutId(offer?.price || this.defaultPrice, currency, additionalPayload, this.paymentReason)
        .subscribe(
          async (res) => {
            if (res?.id) {
              localStorage.setItem("c_id", res?.id);
              try {
                // logic to unload the existing widget
                await this.unloadPaymentWidget();
              } catch (error) {
                return error;
              }
              this.utilityService.loadScriptForPayment([res?.paymentWidgetUrl]);
              this.url = `https://eu-prod.oppwa.com/v1/checkouts/${res?.id}/payment`;
              this.utilityService.checkIframeInputFocus();
            }
          },
          (error) => {
            // Error handled by user-facing toast messages
            this.authService.errorHandlerLogs("An error occurred:", error);
          },
        );
    });

    const offerDocRef = doc(this.firestore, `/general_modules/offer_listing/offers/1152`);
    const getOfferRef = await getDoc(offerDocRef); // getOfferRef is a DocumentSnapshot

    const offer = getOfferRef.data(); // get data directly from DocumentSnapshot
    if (offer) {
      const purchaseDetails = this.formPaymentDataForTopUp(offer);
      purchaseDetails["p_type"] = this.selectedCard;
      this.coPurchaseDetails = { ...purchaseDetails };

      this.paymentService.insertCustomerPurchase(purchaseDetails, "").subscribe(
        (res) => {
          this.paymentDetail = res;
        },
        () => {
          const defaultMsg = {
            message: {
              line_1: "Something went wrong!",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(null, defaultMsg);
        },
      );

      const interval = setInterval(() => {
        if (document.getElementsByClassName("wpwl-form").length) {
          const submitButton = document?.getElementsByClassName("wpwl-button-pay");
          if (submitButton && submitButton.length && submitButton[0]) {
            this.updateButtonTranslation(submitButton[0]);
          }
          this.hideSpinner = true;
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  load() {
    this.count++;
    if (this.count > 1) {
      this.paymentDone = true;
    }
  }

  getSystemPreferenceOfferId() {
    // Step 1: read system_reference doc as Observable from Promise
    const systemRefDoc = doc(this.firestore, `/general_modules/${environment.mirrorPath}system_reference`);

    return from(getDoc(systemRefDoc)).pipe(
      map((snapshot) => snapshot.data()), // extract data from DocumentSnapshot
      switchMap((systemPreference) => {
        if (!systemPreference) {
          // fallback if no systemPreference data
          return of({ price: this.defaultPrice });
        }

        this.offerId = systemPreference.pre_auth_offer_id;
        this.preAuthAmount = systemPreference.pre_auth_amount;

        // Step 2: read offer document
        const offerDocRef = doc(this.firestore, `/general_modules/offer_listing/offers/${this.offerId}`);

        return from(getDoc(offerDocRef)).pipe(
          map((offerSnap) => offerSnap.data()),
          catchError(() => of({ price: this.defaultPrice })),
        );
      }),
      catchError(() => of({ price: this.defaultPrice })),
    );
  }

  afterNewCardPaymentDone() {
    const urlData = JSON.parse(localStorage.getItem("d"));

    if (!this.paymentReceived && urlData) {
      this.paymentReceived = true;
      this.paymentService
        .checkPaymentStatus(urlData?.id, this.paymentMode)
        .pipe(take(1))
        .subscribe(
          (payment_status) => {
            this.payment_status = payment_status;
            if (payment_status) {
              this.angularFireAuth.currentUser
                .then((user) => {
                  if (!user) {
                    let token = localStorage.getItem("fbToken");
                    if (token) {
                      this.manualLoginPayment(token, payment_status);
                    } else {
                      const interval = setInterval(() => {
                        let token = localStorage.getItem("fbToken");
                        if (token) {
                          clearInterval(interval);
                          this.manualLoginPayment(token, payment_status);
                        }
                      }, 1000);
                    }
                  } else {
                    this.handleSuccessPayment(payment_status);
                  }
                })
                .catch((error) => {
                  return error;
                });
            }
          },
          () => {
            this.handleError();
          },
        );
    }
  }

  private manualLoginPayment(token: string, payment_status: Data) {
    this.tokenValidaterSub = this.authService.getV2CloudFunction("tokenvalidater", { token }).subscribe({
      next: (res) => {
        const { status, token, token_refresh } = res;
        if (status && token) {
          if (token_refresh) {
            localStorage.setItem(this.fbTokenKey, token);
          }
          this.angularFireAuth
            .signInWithCustomToken(token)
            .then(() => {
              this.angularFireAuth.currentUser.then((d) => {
                if (d) {
                  this.handleSuccessPayment(payment_status);
                } else {
                  this.paymentDone = false;
                  const defaultMsg = {
                    message: {
                      line_1: "Something went wrong!",
                      line_2: "",
                    },
                    style: {
                      icon: "tick circle error.svg",
                      type: CommonVariable.error,
                    },
                  };
                  this.authService.showToastMessage({}, defaultMsg);
                }
              });
            })
            .catch((error) => {
              const logData = {
                creation_date: new Date(),
                local_fb_token: localStorage.getItem(this.fbTokenKey) || "Missing Token",
                error,
                page: "custom-add-card.component.ts",
                userId: localStorage.getItem(this.userIdKey) || "Missing User ID",
              };
              this.afs
                .collection("/logs/manualLoginPayment/list")
                .add(logData)
                .catch(() => {
                  return false;
                });
              return false;
            });
        }
      },
      error: (err) => {
        return err;
      },
    });
  }

  handleSuccessPayment(payment_status: Data) {
    if (
      payment_status?.result.description.search("successfully") > -1 ||
      payment_status?.result.description.search("succeeded") > -1
    ) {
      this.paymentService
        .updatePaymentReqAndRes(this.paymentDetail, this.payment_status, true)
        .subscribe((sqlAPICall) => {
          if (sqlAPICall && sqlAPICall?.response?.status === "SUCCESS") {
            this.paymentService.emitSyndicatePurchaseComplete();
            this.afs
              .collection("users")
              .doc(this.userId)
              .set(
                {
                  token_exists: true,
                },
                { merge: true },
              )
              .then();
            this.authService
              .getConstantsMsg("1092")
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Card Added Successfully",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle success.png",
                    type: "Success",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((error) => {
                return error;
              });
            this.paymentDone = false;
            this.navController.back();
          }
        });
    } else {
      this.handleError();
    }
  }

  private handleError() {
    this.paymentDone = false;
    const defaultMsg = {
      message: {
        line_1: "Unable to add payment method!",
        line_2: "",
      },
      style: {
        icon: "tick circle error.svg",
        type: "Error",
      },
    };
    this.authService.showToastMessage(defaultMsg, defaultMsg);
    // this.router.navigateByUrl("account/wallet");
    this.navController.back();
  }

  goHome() {
    const hasDuplicate = this.routeStack.length !== new Set(this.routeStack).size;
    if (hasDuplicate) {
      const queryParams = this.actRoute.snapshot?.queryParams ?? {};
      this.routeStack = []; // ✅ clear stack
      this.router.navigate(["mainTabs/tabs/store"], {
        queryParams,
        replaceUrl: true, // ✅ history clean
      });
    } else {
      this.routeStack.pop(); // ✅ maintain stack
      this.navController.back();
    }
  }

  formPaymentDataForTopUp(offer: Data) {
    return {
      prosub_id: offer?.prosub_id,
      phone: offer?.phone,
      prize: offer?.price,
      offers: offer,
      checkout: true,
      draw: "",
      game: "",
      line: "",
      offer_id: offer?.offer_id,
      real_name: "",
      page: "store",
      TP1: "",
      TP2: "",
      TP3: "",
      T_ID: "",
      other: "",
      vc: "",
    };
  }

  async addNewCard() {
    const oldProsub = localStorage.getItem("initialProsub");
    const prosub_id = localStorage.getItem("prosub_id");

    if (oldProsub === prosub_id) {
      const c_Id = localStorage.getItem("c_id");
      if (c_Id && c_Id !== null) {
        try {
          // logic to unload the existing widget
          await this.unloadPaymentWidget();
        } catch (error) {
          return error;
        }
        this.utilityService.loadScriptForPayment([`https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${c_Id}`]);
        this.utilityService.checkIframeInputFocus();

        const partialRegService = this.injector.get(LoginDataResolverService);
        //this.insertCustomerPurchaseRes = partialRegService.insertCustomerPurchaseRes
        localStorage.removeItem("minutes");
        localStorage.removeItem("c_id");
        localStorage.removeItem("initialProsub");

        return;
      } else {
        //this.getPaymentFormLoaded();
      }
      return;
    }

    //this.getPaymentFormLoaded();
  }

  private prefetchCheckoutApiKeys(): void {
    const queryParams = this.actRoute.snapshot.queryParams || {};
    this.paymentService
      ?.getCheckoutApiDetails(queryParams)
      ?.pipe(
        take(1),
        catchError((err) => {
          this.authService.errorHandlerLogs("Checkout.com config prefetch failed:", err);
          return of(null);
        }),
      )
      .subscribe((res: Data) => {
        if (!res?.data?.publicKey) {
          return;
        }
        this.keys = res.data;
        this.checkoutApiKeysReady = true;
        this.scheduleCheckoutWarmStart();
        void this.tryMountCheckoutFlow();
      });
  }

  private canPrepareCheckoutSession(): boolean {
    return !!(
      this.isCheckOutCom &&
      this.checkoutApiKeysReady &&
      this.keys?.publicKey &&
      this.coPurchaseDetails &&
      this.pathString &&
      this.userId &&
      this.preAuthAmount != null
    );
  }

  private scheduleCheckoutWarmStart(): void {
    if (!this.canPrepareCheckoutSession()) {
      return;
    }

    this.resolveCheckoutLanguage();
    void this.accountAddCardCheckoutFlowService.prepareCheckoutSession(this.toFlowHost()).catch((error) => {
      this.authService.errorHandlerLogs("Checkout warm start failed", error);
    });
  }

  private resolveCheckoutLanguage(): void {
    const lang = this.selectedLanguage || "en";
    switch (lang) {
      case "de":
        this.language = "DE-DE";
        break;
      case "es":
        this.language = "ES-ES";
        break;
      case "fr":
        this.language = "FR-FR";
        break;
      case "it":
        this.language = "IT-IT";
        break;
      default:
        this.language = "EN-GB";
    }
  }

  private async tryMountCheckoutFlow(): Promise<void> {
    if (this.flowMountAttempted || !this.canPrepareCheckoutSession()) {
      return;
    }

    this.resolveCheckoutLanguage();
    this.flowMountAttempted = true;
    this.isCheckoutComform = true;
    this.showCheckOutComSpinner = true;
    this.changeDetRef.detectChanges();

    await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));

    try {
      await this.accountAddCardCheckoutFlowService.mountAccountAddCardFlow(this.toFlowHost());
    } catch (error) {
      if ((error as Data)?.code === "checkout_flow_mount_cancelled") { return; }
      this.flowMountAttempted = false;
      this.errorMessage = "Failed to initialize payment form. Please try again later.";
      this.showCheckOutComSpinner = false;
      this.authService.errorHandlerLogs("Checkout Flow mount failed", error);
      this.changeDetRef.detectChanges();
    }
  }

  public ngAfterViewInitCheckout(): void {
    void this.tryMountCheckoutFlow();
  }

  private toFlowHost(): AccountAddCardFlowHost {
    return {
      keys: this.keys,
      language: this.language,
      paymentMode: this.paymentMode,
      pathString: this.pathString,
      userId: this.userId,
      checkOutComData: this.checkOutComData,
      userData: this.userData,
      coPurchaseDetails: this.coPurchaseDetails,
      preferredCurrency: this.preferredCurrency,
      preAuthAmount: this.preAuthAmount,
      paymentReason: this.paymentReason,
      isCheckoutComform: this.isCheckoutComform,
      isButtonDisabled: this.isButtonDisabled,
      showCheckOutComSpinner: this.showCheckOutComSpinner,
      errorMessage: this.errorMessage,
      checkoutFlowReady: this.checkoutFlowReady,
      cardTokenizedCalled: this.cardTokenizedCalled,
      sandbox: this.paymentMode === "sandbox" ? true : false,
      getCheckOutComResponseSubscription: this.getCheckOutComResponseSubscription,
      getCookie: (name) => this.getCookie(name),
      onFlowReady: () => {
        this.checkoutFlowReady = true;
        this.cardTokenizedCalled = false;
        this.isCheckoutComform = true;
        this.showCheckOutComSpinner = false;
        this.isButtonDisabled = !this.checkOutComData?.customer_purchase;
        if (this.accountAddCardCheckoutFlowService.isCheckoutLoadingMessage(this.errorMessage)) {
          this.errorMessage = "";
        }
        this.changeDetRef.detectChanges();
      },
      onFlowPaymentCompleted: () => this.onCheckoutFlowPaymentCompleted(),
    };
  }

  public onCheckoutFlowPaymentCompleted(): void {
    this.cardTokenizedCalled = true;
    this.showCheckOutComSpinner = true;
    this.isCheckoutComform = false;
    this.isButtonDisabled = true;
    this.changeDetRef.detectChanges();
    this.loadingService.present();

    this.accountAddCardCheckoutFlowService.waitForPaymentConfirmation(this.toFlowHost(), {
      onSuccess: () => {
        this.loadingService.dismiss();
        this.paymentService.emitSyndicatePurchaseComplete();
        this.accountAddCardCheckoutFlowService.teardown();
        this.authService
          .getConstantsMsg("1092")
          .then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Card Added Successfully",
                line_2: "",
              },
              style: {
                icon: "tick circle success.png",
                type: "Success",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          .catch((error) => {
            return error;
          });
        this.router.navigateByUrl("/account/wallet");
        this.getCheckOutComResponseSubscription?.unsubscribe();
      },
      onFailure: () => {
        this.loadingService.dismiss();
        this.checkoutPaymentFailedFlow();
      },
      onTimeout: () => {
        this.loadingService.dismiss();
        this.errorMessage = "Payment confirmation timed out. Please try again.";
        this.showCheckOutComSpinner = false;
        this.changeDetRef.detectChanges();
      },
    });
  }

  private handleCheckoutFlowRedirect(): boolean {
    if (this.checkoutFlowRedirectHandled) {
      return true;
    }

    const redirectReturn = this.checkoutFlowService.parseRedirectReturn(this.actRoute.snapshot.queryParams ?? {});
    if (!redirectReturn.isRedirectReturn) {
      return false;
    }

    this.checkoutFlowRedirectHandled = true;

    if (redirectReturn.logId) {
      this.pathString = redirectReturn.logId;
      this.paymentService.syncCheckoutFlowStatus({ logId: redirectReturn.logId });
    }
    if (redirectReturn.userId) {
      this.userId = redirectReturn.userId;
      this.paymentService.checkoutFlowUserId$.next(redirectReturn.userId);
    }

    this.isCheckOutCom = true;
    this.isPaymill = false;
    this.showCheckOutComSpinner = true;
    this.changeDetRef.detectChanges();

    if (redirectReturn.status === "success") {
      this.onCheckoutFlowPaymentCompleted();
      this.clearCheckoutFlowReturnQueryParams();
      return true;
    }

    if (redirectReturn.status === "fail") {
      this.errorMessage = "Payment failed, please try again.";
      this.showCheckOutComSpinner = false;
      this.changeDetRef.detectChanges();
      this.clearCheckoutFlowReturnQueryParams();
      return true;
    }

    this.clearCheckoutFlowReturnQueryParams();
    return true;
  }

  private clearCheckoutFlowReturnQueryParams(): void {
    const cleaned = this.checkoutFlowService.stripRedirectReturnParams({
      ...(this.actRoute.snapshot.queryParams ?? {}),
    });
    this.paymentMode = "";
    this.cardTokenizedCalled = false;
    void this.router.navigate([], {
      relativeTo: this.actRoute,
      queryParams: cleaned,
      replaceUrl: true,
    });
  }

  public isCheckoutLoadingMessage(message: string): boolean {
    return this.accountAddCardCheckoutFlowService.isCheckoutLoadingMessage(message);
  }

  public onSubmit(event: Event): void {
    event.preventDefault();
    if (!this.checkOutComData?.customer_purchase) {
      this.errorMessage = "Payment is still loading. Please wait a moment.";
      this.changeDetRef.detectChanges();
      return;
    }
    this.accountAddCardCheckoutFlowService.submitPayment();
  }

  updateButtonTranslation(button): void {
    const node = "add-new-card.verify-card";
    this.translate
      .get([node])
      ?.pipe(takeUntil(this.unsubscribe$))
      ?.subscribe({
        next: (res: Data) => {
          const defaultValue = "Verify card";
          const verifyText = res[node];
          button.innerHTML = verifyText || defaultValue;
        },
        error: (err) => {
          return err;
        },
      });
  }

  ngOnDestroy(): void {
    this.accountAddCardCheckoutFlowService.teardown();
    this.unsubscribe$?.next();
    this.unsubscribe$?.complete();
    if (this.tokenValidaterSub) {
      this.tokenValidaterSub.unsubscribe();
    }
    this.getCheckOutComResponseSubscription?.unsubscribe();
  }

  // This function used to get cookie value to the given name.
  private getCookie(name) {
    try {
      var nameEQ = name + "=";
      var cookie = document.cookie?.split(";");
      for (var i = 0; i < cookie.length; i++) {
        var c = cookie[i];
        while (c.charAt(0) == " ") c = c?.substring(1, c.length);
        if (c?.indexOf(nameEQ) == 0) return c?.substring(nameEQ.length, c.length);
      }
      return null;
    } catch (e) {
      return e;
    }
  }

  private async unloadPaymentWidget(): Promise<void> {
    try {
      if (window.wpwl !== undefined && window.wpwl?.unload !== undefined) {
        await window.wpwl.unload();

        // Remove scripts using Renderer2
        const scripts = document.querySelectorAll('script[src*="static.min.js"]');
        scripts.forEach((script) => {
          this.renderer.removeChild(document.body, script);
        });
      }
    } catch (error) {
      return error; // Rethrow the error for proper handling
    }
  }

  private checkoutPaymentFailedFlow(): void {
    this.loadingService.dismiss();
    this.accountAddCardCheckoutFlowService.teardown();
    this.flowMountAttempted = false;
    this.cardTokenizedCalled = false;
    this.checkoutFlowReady = false;
    this.isCheckoutComform = true;
    this.showCheckOutComSpinner = false;
    this.redirectlink = this.sanitizer.bypassSecurityTrustResourceUrl(
      environment.checkOutUrl
    );
    this.authService
      .getConstantsMsg("1093")
      .then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "There is an issue in processing payment",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      })
      .catch((error) => {
        return error;
      });
  }
}
